import { FormattedOption } from 'types/dictionaries';

const getOptionLabel = (
  value: string,
  options: FormattedOption[] = []
): string => {
  const option = options.find((opt) => opt.value === value);
  return typeof option?.label === 'string' ? option.label : value;
};

export default getOptionLabel;
